import React from 'react';
import './body.css';
import 'antd/dist/antd.css';
import '@ant-design/compatible';
import { withRouter } from 'react-router';
import { Alert, Button, Layout, Spin } from 'antd';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import { ApolloProvider } from 'react-apollo';
import cubejs from '@cubejs-client/core';
import { CubeProvider } from '@cubejs-client/react';
import { useAuth } from 'react-oidc-context';

import Header from './components/Header';
import client from './graphql/client';
import { getPortalToken } from './auth';
import { fetchApiKeyIfMissing } from './common/helpers';

export const REACT_APP_VERTX_API_BASE = process.env.REACT_APP_VERTX_API_BASE;
export const REACT_APP_CUBEJS_API_URL = process.env.REACT_APP_CUBEJS_API_URL;

const cubejsApi = cubejs(async () => `Bearer ${await getPortalToken()}`, {
  apiUrl: `${REACT_APP_CUBEJS_API_URL}/cubejs-api/v1`,
});

const AppLayout = ({ location, children }) => (
  <Layout style={{ height: '100%' }}>
    <Header location={location} />
    <Layout.Content>{children}</Layout.Content>
  </Layout>
);

const AuthStateApp = withRouter(({ location, children }) => {
  const auth = useAuth();
  const subject = auth.user?.profile?.sub;

  React.useEffect(() => {
    if (!auth.isAuthenticated || !subject) return;
    const identity = `${auth.user.profile.iss}|${subject}`;
    if (localStorage.getItem('vertx_identity') !== identity) {
      localStorage.removeItem('vertx_data');
      localStorage.setItem('vertx_identity', identity);
      client.clearStore();
    }
    fetchApiKeyIfMissing(REACT_APP_VERTX_API_BASE, null, null);
  }, [auth.isAuthenticated, subject, auth.user]);

  if (auth.isLoading || auth.activeNavigator) {
    return <Spin style={{ margin: 32 }} />;
  }

  if (auth.error) {
    return <Alert type="error" showIcon message="Sign-in failed" description={auth.error.message}
      action={<Button onClick={() => auth.signinRedirect({ state: { returnTo: location.pathname } })}>Try again</Button>} />;
  }

  if (!auth.isAuthenticated) {
    return <Layout style={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <h1>Vertx Portal</h1>
      <Button type="primary" onClick={() => auth.signinRedirect({ state: { returnTo: location.pathname + location.search } })}>
        Sign in
      </Button>
    </Layout>;
  }

  return <CubeProvider cubejsApi={cubejsApi}>
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <AppLayout location={location}>{children}</AppLayout>
      </ApolloHooksProvider>
    </ApolloProvider>
  </CubeProvider>;
});

export default AuthStateApp;
